import { generatorAuth } from 'src/tools/helper';
//import { useRef } from 'react';
import { useWebSocket as uW } from 'ahooks';
enum ReadyState {
  Connecting = 0,
  Open = 1,
  Closing = 2,
  Closed = 3,
}
const useWebSocket = ({ onMessage, onError, onOpen, onClose }) => {
  const query = `access_token=${generatorAuth()}`;
  const url = `${process.env.REACT_COLLOBRATION_URL}?${query}`;
  const {
    sendMessage: send,
    disconnect: close,
    readyState,
  } = uW(url, {
    onMessage,
    onError: (e) => {
      // console.log(123);
      if (onError) {
        onError(e);
      } else {
        console.error(e);
      }
    },
    onOpen,
    onClose,
    reconnectLimit: 2,
    reconnectInterval: 3000,
  });

  const handleOnSend = (json: any) => {
    if (readyState === ReadyState.Open) {
      send(json);
    }
  };

  return {
    send: handleOnSend,
    close,
    isConnected: readyState === ReadyState.Open,
    isClosed: readyState === ReadyState.Closed,
    isConnecting: readyState === ReadyState.Connecting,
  };
};
export { useWebSocket };
